const PALETTE = [
  "#dc2626", "#f59e0b", "#2563eb", "#059669", "#7c3aed", "#0891b2", "#64748b",
];

const monthLabel = (m) => {
  const [y, mo] = m.split("-");
  const d = new Date(Number(y), Number(mo) - 1, 1);
  return d.toLocaleDateString(undefined, { month: "short" });
};

export function TrendChart({ months = [], series = [], totals = [] }) {
  const max = Math.max(...totals, 1);
  const hasData = totals.some((t) => t > 0);

  return (
    <div data-testid="trend-chart">
      <div className="flex items-end gap-2 h-44 mt-2">
        {months.map((m, i) => (
          <div key={m} className="flex-1 flex flex-col items-center justify-end h-full group">
            <span className="text-[10px] text-muted-foreground mb-1 tabular-nums opacity-0 group-hover:opacity-100 transition-opacity">
              {totals[i] || ""}
            </span>
            <div className="w-full flex flex-col-reverse rounded-t overflow-hidden" style={{ height: "100%" }}>
              {series.map((s, si) => {
                const v = s.values[i] || 0;
                if (!v) return null;
                return (
                  <div key={s.region} title={`${s.region}: ${v}`}
                    style={{ height: `${(v / max) * 100}%`, backgroundColor: PALETTE[si % PALETTE.length] }}
                    className="w-full transition-all duration-500" />
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <div className="flex gap-2 mt-2">
        {months.map((m) => (
          <span key={m} className="flex-1 text-center text-[10px] text-muted-foreground">{monthLabel(m)}</span>
        ))}
      </div>
      {!hasData && (
        <p className="text-sm text-muted-foreground text-center mt-4">No approvals recorded in the last 12 months yet.</p>
      )}
      {series.length > 0 && (
        <div className="flex flex-wrap gap-x-4 gap-y-1.5 mt-4">
          {series.map((s, si) => (
            <div key={s.region} className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-sm" style={{ backgroundColor: PALETTE[si % PALETTE.length] }} />
              <span className="text-xs text-muted-foreground">{s.region}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
